export type Layout = "Desktop" | "Phone";
let overrideLayout: Layout;

export function setLayout(layout: Layout): void {
    overrideLayout = layout;
}

export function getLayout(): Layout {
    return overrideLayout || "Desktop";
}
